import { Routes, UrlSegment } from '@angular/router';
import { CookieSettingsGuard } from '@teamfoster/sdk/cookie-ngrx';
import { DictionaryGuard } from '@teamfoster/sdk/dictionary-ngrx';
import { MenuGuard } from '@teamfoster/sdk/menu-ngrx';
import { NotFoundComponent } from './404.component';
import { WebsiteLayoutComponent } from './layouts/website-layout/website-layout.component';
import { SocialChannelsGuard } from './social-media/guards';

const appGuards = [CookieSettingsGuard, MenuGuard, DictionaryGuard, SocialChannelsGuard];

export const routes: Routes = [
  {
    path: '',
    component: WebsiteLayoutComponent,
    pathMatch: 'prefix',
    canActivate: [...appGuards],
    data: {
      hoi: 'test',
    },
    children: [
      {
        path: 'styleguide',
        loadChildren: () => import('./styleguide/styleguide.routes').then(m => m.routes),
      },
      {
        path: 'contentblokken',
        pathMatch: 'prefix',
        loadChildren: () => import('./content-blocks/content-blocks.routes').then(m => m.routes),
      },
      {
        path: 'aanbod-in-de-buurt',
        pathMatch: 'prefix',
        loadChildren: () => import('./objects-nearby/objects-nearby.routes').then(m => m.routes),
      },
      {
        path: 'successverhaal',
        pathMatch: 'prefix',
        loadChildren: () => import('./success-stories/success-story.routes').then(m => m.routes),
      },
      {
        path: 'team',
        pathMatch: 'prefix',
        loadChildren: () => import('./team/team.routes').then(m => m.routes),
      },
      {
        path: '404',
        component: NotFoundComponent,
      },
      {
        path: '',
        pathMatch: 'prefix',
        loadChildren: () => import('./landing-pages/landing-pages.routes').then(m => m.routes),
      },
      {
        path: '**',
        redirectTo: '/404',
      },
    ],
  },
];
